import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { clearUsersState, fetchUsers } from './userSlice';
import { fetchSettings } from './settingSlice';
import { clearAuthData, fetchMe } from './authSlice';
import { clearOrdersState } from './orderSlice';
import { clearSettingsState } from './settingSlice';
import { clearOfficeState } from './officeSlice';
import { clearAdvertsState } from './advertSlice';

const initialState = {
    isLoaded: false,
    isLightTheme: localStorage.getItem('isLightTheme') === null ? false : localStorage.getItem('isLightTheme') === 'false' ? false: true,
};

export const initApp = createAsyncThunk('app/initApp', async (_, thunkAPI) => {
    const data = (await thunkAPI.dispatch(fetchMe())).payload;
    if (data.isOkay) {  //Если авторизованы
        await thunkAPI.dispatch(fetchUsers());
        const usersList = (thunkAPI.getState()).users.list; 
        await thunkAPI.dispatch(fetchSettings(usersList));
    }
    thunkAPI.dispatch(initializeApp({}));
});

export const resetAppState = createAsyncThunk('app/reload', async (_, ThunkAPI) => {
    ThunkAPI.dispatch(clearAuthData())
    ThunkAPI.dispatch(clearOrdersState());
    ThunkAPI.dispatch(clearUsersState());
    ThunkAPI.dispatch(clearOfficeState());
    ThunkAPI.dispatch(clearAdvertsState());
    ThunkAPI.dispatch(clearSettingsState());
})

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        initializeApp(state, _) {
            state.isLoaded = true;
        },
        reloadApp(state, _) {
            state.isLoaded = false;
        },
        switchTheme(state, _) {
            state.isLightTheme = !state.isLightTheme;
            localStorage.setItem('isLightTheme', String(state.isLightTheme));
        },
    },
    extraReducers: (builder) => {
        
    },
});

export const { initializeApp, reloadApp, switchTheme } = appSlice.actions;

export default appSlice.reducer;
